<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title float-start">Template PI Edit</h4>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    id="inputForm"
                    method="POST"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="row mb-3">
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("companyTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <v-select
                              :options="fetchCompany"
                              v-model="selectedCompany"
                              @search="asyncSearchCompany"
                              return-object
                              label="code"
                            >
                              <template slot="option" slot-scope="option">
                                {{ option.code }} - {{ option.name }}
                              </template>
                            </v-select>
                            <div v-if="errors.company_id">
                              <div
                                v-for="error in errors.company_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("companyCode")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <input
                              type="text"
                              class="form-control"
                              id="code"
                              :placeholder="$t('companyCode')"
                              :value="selectedCompany?.code"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("companyName")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <input
                              type="text"
                              class="form-control"
                              id="code"
                              :placeholder="$t('companyName')"
                              :value="selectedCompany?.name"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("sap_code")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <input
                              type="text"
                              class="form-control"
                              id="code"
                              :placeholder="$t('sap_code')"
                              :value="selectedCompany?.sap_code"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("piTemplateName")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <input
                              type="text"
                              class="form-control"
                              id="template_name"
                              :placeholder="$t('piTemplateName')"
                              v-model="forms.template_name"
                            />
                            <div v-if="errors.template_name">
                              <div
                                v-for="error in errors.template_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("description_txt")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <textarea
                              class="form-control"
                              id="description"
                              v-model="forms.description"
                            ></textarea>
                            <div v-if="errors.description">
                              <div
                                v-for="error in errors.description"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div class="row mb-3">
                    <nav>
                      <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                          v-for="(sheet, key) in sheets"
                          :key="key"
                          class="nav-link"
                          data-bs-toggle="tab"
                          role="tab"
                          :id="'nav-' + sheet.detail_name.replaceAll(' ', '_')"
                          :href="'#' + sheet.detail_name.replaceAll(' ', '_')"
                          >{{ sheet.detail_alias }}</a
                        >

                        <button
                          class="nav-link"
                          style="color: white; background-color: #198754"
                          type="button"
                          @click="addSheet"
                        >
                          <i class="mdi mdi-plus"></i> Add Sheet
                        </button>
                      </div>
                    </nav>
                    <div class="tab-content" id="myTabContent">
                      <div
                        v-for="(sheet, key) in sheets"
                        :key="key"
                        class="tab-pane fade"
                        :id="sheet.detail_name.replaceAll(' ', '_')"
                        role="tabpabel"
                        :aria-labelledby="
                          sheet.detail_name.replaceAll(' ', '_') + '-tab'
                        "
                      >
                        <div class="col-lg-12 col-xl-12 stretch-card mb-3">
                          <div class="card card-custom">
                            <div class="card-body mt-2">
                              <div class="row">
                                <div class="col-sm-2">
                                  <div class="mb-3">
                                    <label class="form-label">Sheet Name</label>
                                    <input
                                      type="text"
                                      disabled
                                      class="form-control"
                                      v-model="sheet.detail_name"
                                      placeholder="Sheet Name"
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Sheet Alias</label
                                    >
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="sheet.detail_alias"
                                      placeholder="Sheet Alias"
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Sheet Order</label
                                    >
                                      <div class="mb-3 mt-1">
                                        <button class="btn btn-sm btn-twitter mx-2" type="button" @click="moveSheetUp(key)" :disabled="key === 0"><i class="mdi mdi-arrow-left"></i></button>    
                                        <button class="btn btn-sm btn-twitter mx-2" type="button" @click="moveSheetDown(key)" :disabled="sheets ? key === sheets.length - 1 : false"><i class="mdi mdi-arrow-right"></i></button>    
                                    </div>
                                    <!-- <input
                                      type="number"
                                      class="form-control"
                                      v-model="sheet.detail_order"
                                      placeholder="Sheet Order"
                                    /> -->
                                  </div>
                                  <div class="mb-3">
                                    <button
                                      class="btn btn-danger"
                                      @click="deleteSheet(key, sheet)"
                                      type="button"
                                      :disabled="sheets.length === 1"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                                <div class="col-sm-10">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <div class="card">
                                        <div class="card-header">
                                          <h5>Field List</h5>
                                        </div>
                                        <div class="card-body">
                                          <TemplateSettingCustomTable
                                            :rows="sheet.fieldList"
                                            :columns="fieldListColumn"
                                            row-key-field="proforma_invoice_template_field_list_id"
                                          >
                                            <template
                                              slot="cell"
                                              slot-scope="props"
                                            >
                                              <span v-if="props.column.field == 'actions'">
                                                <button
                                                  class="btn btn-sm btn-icon btn-primary"
                                                  title="Move"
                                                  type="button"
                                                  :disabled="
                                                    checkDisabled(
                                                      props.row,
                                                      sheet,
                                                    )
                                                  "
                                                  @click.prevent="
                                                    moveFieldtoSelected(
                                                      props.sourceIndex,
                                                      props.row,
                                                      sheet,
                                                    )
                                                  "
                                                >
                                                  <i
                                                    class="mdi mdi-menu-right"
                                                    style="font-size: 16px"
                                                  ></i>
                                                </button>
                                              </span>
                                              <span v-else>
                                                {{ props.value }}
                                              </span>
                                            </template>
                                          </TemplateSettingCustomTable>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="card">
                                        <div class="card-header">
                                          <h5>Selected Field</h5>
                                        </div>
                                        <div class="card-body">
                                          <TemplateSettingCustomTable
                                            :rows="sheet.field"
                                            :columns="selectedFieldColumn"
                                            sort-field="field_order"
                                            sort-type="asc"
                                          >
                                            <template
                                              slot="cell"
                                              slot-scope="props"
                                            >
                                              <span v-if="props.column.field == 'actions'">
                                                <button
                                                  v-if="!props.row.is_edit"
                                                  class="btn btn-xs btn-icon btn-warning mx-1"
                                                  type="button"
                                                  @click="
                                                    editRow(
                                                      props.sourceIndex,
                                                      props.row,
                                                    )
                                                  "
                                                >
                                                  <i
                                                    class="mdi mdi-pencil"
                                                    style="font-size: 16px"
                                                  ></i>
                                                </button>
                                                <button
                                                  v-if="!props.row.is_edit"
                                                  class="btn btn-xs btn-icon btn-danger mx-1"
                                                  type="button"
                                                  :disabled="
                                                    props.row.required == '1'
                                                  "
                                                  @click="
                                                    deleteRow(
                                                      props.sourceIndex,
                                                      props.row,
                                                      sheet,
                                                    )
                                                  "
                                                >
                                                  <i
                                                    class="mdi mdi-delete"
                                                    style="font-size: 16px"
                                                  ></i>
                                                </button>
                                                <button
                                                  v-if="props.row.is_edit"
                                                  type="button"
                                                  class="btn btn-xs btn-icon btn-success mx-1"
                                                  @click="
                                                    saveEdit(
                                                      props.sourceIndex,
                                                      props.row,
                                                      sheet,
                                                    )
                                                  "
                                                >
                                                  <i
                                                    class="mdi mdi-content-save"
                                                    style="font-size: 16px"
                                                  ></i>
                                                </button>
                                              </span>
                                              <span
                                                v-else-if="
                                                  props.column.field ==
                                                  'field_lable'
                                                "
                                                >{{
                                                  props.row?.field?.field_lable
                                                }}</span
                                              >
                                              <span
                                                v-else-if="
                                                  props.column.field ==
                                                  'field_order'
                                                "
                                              >
                                                <div
                                                  class="btn-group"
                                                  role="group"
                                                  aria-label="Update Sorting"
                                                >
                                                  <button
                                                    type="button"
                                                    :disabled="
                                                      props.row.field_order == 0
                                                    "
                                                    class="btn btn-twitter btn-xs btn-icon"
                                                    @click="
                                                      updateSortUp(
                                                        props.sourceIndex,
                                                        props.row,
                                                        sheet.field,
                                                      )
                                                    "
                                                  >
                                                    <i
                                                      class="mdi mdi-menu-up"
                                                    ></i>
                                                  </button>
                                                  <button
                                                    type="button"
                                                    class="btn btn-youtube btn-xs btn-icon"
                                                    :disabled="
                                                      props.row.field_order ==
                                                      sheet.field.length - 1
                                                    "
                                                    @click="
                                                      updateSortDown(
                                                        props.sourceIndex,
                                                        props.row,
                                                        sheet.field,
                                                      )
                                                    "
                                                  >
                                                    <i
                                                      class="mdi mdi-menu-down"
                                                    ></i>
                                                  </button>
                                                </div>
                                              </span>
                                              <span
                                                v-else-if="
                                                  props.column.field ==
                                                  'field_alias'
                                                "
                                              >
                                                <span
                                                  v-show="!props.row.is_edit"
                                                  >{{
                                                    props.row.field_alias
                                                  }}</span
                                                >
                                                <input
                                                  v-show="props.row.is_edit"
                                                  type="text"
                                                  v-model="
                                                    props.row.field_alias_temp
                                                  "
                                                  class="form-control"
                                                />
                                              </span>
                                              <span
                                                v-else-if="
                                                  props.column.field ==
                                                  'required'
                                                "
                                              >
                                                <input
                                                  type="checkbox"
                                                  :value="props.row.required"
                                                  @change="
                                                    triggerChangeCheckbox(
                                                      props.index,
                                                      props.row,
                                                      sheet,
                                                    )
                                                  "
                                                />
                                              </span>
                                              <span v-else>
                                                {{ props.value }}
                                              </span>
                                            </template>
                                          </TemplateSettingCustomTable>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <button
                      class="btn btn-warning text-black fw-bolder btn-icon-text"
                      @click="backForm"
                      type="button"
                    >
                      <i class="link-icon" data-feather="arrow-left"></i>
                      {{ $t("backMess") }}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      class="btn btn-primary float-end btn-sm"
                      type="submit"
                      form="inputForm"
                    >
                      <i class="link-icon" data-feather="save"></i>
                      {{ $t("submitFormTxt") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import TemplateSettingCustomTable from "@/components/proformaInvoice/templateSetting/TemplateSettingCustomTable.vue";
export default {
  name: "TemplateSettingAdd",
  computed: {
    fieldListColumn() {
      return [
        {
          label: "Field Name",
          field: "field_lable",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Field Description",
          field: "field_description",
          headerClass: "template-setting-col-description",
          cellClass: "template-setting-col-description",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Action",
          field: "actions",
          sortable: false,
        },
      ];
    },
    selectedFieldColumn() {
      return [
        {
          label: "Field Name",
          field: "field_lable",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
          sortable: false,
        },
        // {
        //   label: "Req ?",
        //   field: "required",
        //   sortable: false,

        // },
        {
          label: "Field Alias",
          field: "field_alias",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
          sortable: false,
        },
        {
          label: "Sort",
          field: "field_order",
          sortable: false,
        },
        {
          label: "Action",
          field: "actions",
          sortable: false,
        },
      ];
    },
  },
  props: {},
  components: {
    sidebarComponent,
    navbarComponent,
    footerComponent,
    TemplateSettingCustomTable,
  },
  data() {
    return {
      closeBtn: true,
      permision_role: [],
      isLoading: false,
      errors: [],
      forms: {},
      fetchCompany: [],
      selectedCompany: null,
      fetchFieldList: [],

      sheets: [],
      selectedSheet: null,
      countSheet: 0,
    };
  },
  watch: {},
  methods: {
    moveSheetUp(index) {
      if (index === 0) return;
      let temp = this.sheets[index - 1];
      this.$set(temp, "detail_order", index);

      let current = this.sheets[index];
      this.$set(current, "detail_order", index - 1);

      this.$set(this.sheets,index-1,current);
      this.$set(this.sheets,index,temp);

      this.specificSelectedSheet(index-1);
    },

    moveSheetDown(index) {
      if (index === this.sheets.length - 1) return;

      const temp = this.sheets[index + 1];
      this.$set(temp, "detail_order", index);

      let current = this.sheets[index];
      this.$set(current, "detail_order", index + 1);

      this.$set(this.sheets,index+1,current);
      this.$set(this.sheets,index,temp);

      this.specificSelectedSheet(index+1);

    },
    triggerChangeCheckbox(index, row, sheet) {
      const newValue = !row.required;
      const rowIndex = sheet.field.findIndex(
        (item) =>
          item.proforma_invoice_template_field_list_id ==
          row.proforma_invoice_template_field_list_id,
      );
      if (rowIndex !== -1) {
        this.$set(sheet.field[rowIndex], "required", newValue);
      }
    },
    deleteSheet(index) {
      if (this.sheets.length === 1) {
        return;
      }
      let sheetDuplicate = [...this.sheets];
      sheetDuplicate.splice(index, 1);
      this.sheets = sheetDuplicate;
    },
    reSortField(fields) {
      let a = 0;
      fields.forEach(function (val) {
        if (val.field_order !== a) {
          val.field_order = a;
        }
        a++;
      });
      return fields;
    },
    updateSortUp(index, row, fields) {
      let changedRowIndex = fields.findIndex(
        (arr) => arr.field_order == row.field_order - 1,
      );
      let currentRow = fields.findIndex(
        (arr) =>
          arr.proforma_invoice_template_field_list_id ==
          row.proforma_invoice_template_field_list_id,
      );
      this.$set(fields[changedRowIndex], "field_order", row.field_order);
      this.$set(fields[currentRow], "field_order", row.field_order - 1);
    },
    updateSortDown(index, row, fields) {
      let changedRowIndex = fields.findIndex(
        (arr) => arr.field_order == row.field_order + 1,
      );
      let currentRow = fields.findIndex(
        (arr) =>
          arr.proforma_invoice_template_field_list_id ==
          row.proforma_invoice_template_field_list_id,
      );
      this.$set(fields[changedRowIndex], "field_order", row.field_order);
      this.$set(fields[currentRow], "field_order", row.field_order + 1);
    },
    checkDisabled(row, sheet) {
      let fields = sheet.field;
      let exists = false;
      fields.some(function (el) {
        if (
          el.proforma_invoice_template_field_list_id ==
          row.proforma_invoice_template_field_list_id
        ) {
          exists = true;
          return;
        }
      });
      return exists;
    },
    deleteRow(index, row, sheet) {
      let fields = [...sheet.field];
      let currentRow = fields.findIndex(
        (arr) =>
          arr.proforma_invoice_template_field_list_id ==
          row.proforma_invoice_template_field_list_id,
      );
      fields.splice(currentRow, 1);
      fields.sort((a, b) => a.field_order - b.field_order);
      fields = this.reSortField(fields);
      this.$set(sheet, "field", fields);
    },
    editRow(index, row) {
      this.$set(row, "is_edit", true);
    },
    saveEdit(index, row, sheet) {
      const rowIndex = sheet.field.findIndex(
        (item) =>
          item.proforma_invoice_template_field_list_id ==
          row.proforma_invoice_template_field_list_id,
      );
      if (rowIndex === -1) {
        return;
      }

      this.$set(sheet.field[rowIndex], "field_alias", row.field_alias_temp);
      this.$set(sheet.field[rowIndex], "field_alias_temp", row.field_alias_temp);
      this.$set(sheet.field[rowIndex], "is_edit", false);
    },
    moveFieldtoSelected(index, row, sheet) {
      let countField = sheet.field.length;
      let arr = {
        field: row,
        field_order: countField,
        field_alias: row.field_lable,
        field_alias_temp: row.field_lable,
        proforma_invoice_template_field_list_id:
          row.proforma_invoice_template_field_list_id,
        required: false,
      };
      sheet.field.push(arr);
    },

    addSheet() {
      // let countSheet = this.sheets.length;
      let sheetName = "Sheet " + (this.countSheet + 1);
      let count = 0;
      let requiredField = this.fetchFieldList
        .filter((arr) => arr.required == "1")
        .map((item) => {
          let arr = {
            field: item,
            field_order: count,
            field_alias: item.field_lable,
            field_alias_temp: item.field_lable,
            proforma_invoice_template_field_list_id:
              item.proforma_invoice_template_field_list_id,
            required: item.required,
          };
          count++;
          return arr;
        });
      let arr = {
        detail_name: sheetName,
        detail_alias: sheetName,
        detail_order: this.countSheet,
        fieldList: this.fetchFieldList,
        field: requiredField,
      };

      this.countSheet++;

      this.sheets.push(arr);
      this.updateSelectedSheet();
    },
    updateSelectedSheet() {
      this.$nextTick(() => {
        const navLinks = this.$el.querySelectorAll(".nav-tabs .nav-link");
        navLinks.forEach((el) => el.classList.remove("active"));
        if (navLinks.length) {
          navLinks[navLinks.length - 2].classList.add("active");
        }
        // TAB CONTENT
        const tabPanes = this.$el.querySelectorAll(".tab-content .tab-pane");
        tabPanes.forEach((el) => el.classList.remove("active", "show"));

        if (tabPanes.length) {
          tabPanes[tabPanes.length - 1].classList.add("active", "show");
        }
      });
    },
    specificSelectedSheet(index) {
      console.log(index);
      this.$nextTick(() => {
        const navLinks = this.$el.querySelectorAll(".nav-tabs .nav-link");
        navLinks.forEach((el) => el.classList.remove("active"));
        if (navLinks.length) {
          navLinks[index].classList.add("active");
        }
        // TAB CONTENT
        const tabPanes = this.$el.querySelectorAll(".tab-content .tab-pane");

        tabPanes.forEach((el) => el.classList.remove("active", "show"));

        if (tabPanes.length) {
          tabPanes[index].classList.add("active", "show");
        }
      });
    },
    submitData() {
      var id = this.$onBehind(this.$route.params.id)[0];
      const baseURI =
        this.$settings.endPointProformaInvoice + `v1/template-pi/update/${id}`;

      let details = this.sheets.map((el) => {
        const copy = { ...el };
        delete copy.fieldList;
        return copy;
      });

      let send = {
        company_id: this.selectedCompany
          ? this.selectedCompany?.company_id
          : null,
        template_name: this.forms.template_name ?? null,
        description: this.forms.description ?? null,
        detail: details,
      };
      this.fade(true);
      this.$http
        .patch(baseURI, send)
        .then((response) => {
          if (response.data.status === 200) {
            this.errors = [];

            console.log(response);
            var params = this.$onRandom(
              response.data.datas.proforma_invoice_template_header_id,
            );
            window.location.href =
              "/proforma-invoice/template-setting/detail/" +
              params +
              "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        })
        .finally(() => {
          this.loading();
        });
    },
    async loadFieldList() {
      const baseURI =
        this.$settings.endPointProformaInvoice +
        `v1/template-pi/get-available-field`;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFieldList = response.data.datas;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + `/company`;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncSearchCompany(ev, loading) {
      this.fetchCompany = [];
      // loading = true;
      // this.success(ev);
      loading(true);
      const baseURI = this.$settings.endPoint + `/company?code=${ev}`;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        })
        .finally(() => {
          loading(false);
        });
    },
    backForm() {
      window.location.href = "/proforma-invoice/template-setting/";
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "TemplatePIController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    fade(type) {
      this.isLoading = type;
    },
    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },
    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    error(kata) {
      this.$toast.error(kata, { position: "top-right" });
    },
    loadData() {
      var id = this.$onBehind(this.$route.params.id)[0];
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice + `v1/template-pi/detail/${id}`;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.forms = response.data.datas;
          this.selectedCompany = this.forms.company;
          this.sheets = this.forms.detail;
          this.sheets.forEach((item) => {
            this.$set(item, "field", item.detail_field);
            this.$set(item, "fieldList", this.fetchFieldList);
            this.$delete(item, "detail_field");
          });

          this.countSheet = this.sheets.length;
          console.log(this.sheets);

          this.$nextTick(() => {
            this.specificSelectedSheet(0);
          });
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  async mounted() {
    this.fetchIt();
    this.loadCompany();
    await this.loadFieldList();
    this.loadData();
  },
  created() {},
};
</script>
<style scoped>
.card-custom {
  border-radius: 0% !important;
}
</style>
